import { Settings } from 'luxon';
import { getLocale } from '@/i18n/locale';

// Luxon's relative-time formatting (used by `formatAgo`) reads from
// Settings.defaultLocale. nn-NO maps to nb-NO: ICU carries no separate
// Nynorsk date data, so the old bare 'NO' region tag already resolved to
// Bokmål — nb-NO keeps that output but is a valid BCP-47 language tag.
Settings.defaultLocale = getLocale() === 'nn-NO' ? 'nb-NO' : getLocale();
